import type { RouteRecordRaw } from "vue-router";

export const schedulingRoutes: RouteRecordRaw = {
    path: '/appointment',
    children: [
        {
            name: 'Create Appointment',
            path: 'create',
            component: () => import('./appointment/create/AppointmentCreate.vue')
        },
        {
            name: 'Appointment Summary',
            path: 'summary',
            component: () => import('./appointment/summary/AppointmentSummary.vue')
        },
        {
            name: 'Shot Clinic',
            path: 'shot-clinic',
            component: () => import('./appointment/shot-clinic/ShotClinic.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Shelterluv Import',
            path: 'shelter-luv',
            component: () => import('./shelters/shelter-luv/ShelterLuv.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'PetPoint Import',
            path: 'pet-point',
            component: () => import('./shelters/pet-point/PetPoint.vue'),
            meta: { defaultLayout: true }
        }
    ]
}

export const calendarRoutes: RouteRecordRaw = {
    path: '/calendar',
    children: [
        {
            name: 'Spay/Neuter Calendar',
            path: 'spay-neuter',
            component: () => import('./spay-neuter-calendar/SpayNeuterCalendar.vue')
        },
        {
            name: 'Wellness Calendar',
            path: 'wellness',
            component: () => import('./wellness-calendar/WellnessPage.vue')
        }
    ]
}